import {createFileRoute} from '@tanstack/react-router';
import {DepositApplicationPage} from 'features/deposit/onboarding/pages/application/DepositApplicationPage';

export const Route = createFileRoute(
  '/_protected/deposit-onboarding/$applicationId/',
)({
  component: DepositApplicationPage,
});
